<template>
  <div class="page_content">
    <!-- 层级列表 -->
    <LeftHierarchy ref="leftHierarchyRef" />
    <!-- 设备列表 -->
    <RightDevice ref="rightDeviceRef" />
  </div>
</template>

<script>
import LeftHierarchy from "./children/left-hierarchyList.vue";
import RightDevice from "./children/right-deviceList.vue";
export default {
  name: "DeviceList",
  components: { LeftHierarchy, RightDevice },
  provide() {
    return {
      equipmentPage: this,
    };
  },
};
</script>

<style scoped lang='less'>
.page_content {
  padding-top: 10px;
  padding-bottom: 30px;
  display: flex;
  height: calc(100% - 105px);
  overflow: hidden !important;
}
</style>